import React from 'react'
import styled from 'styled-components'
import { headerFontSize } from '../../Constants';

export default function VizHeader({children, type, isBold=false, color=undefined}) {
    const Header = styled.span`
    color:${color===undefined?'#000000':color};
    text-transform:capitalize;
    font-size:${headerFontSize[type-1]}px;
    font-weight:${isBold?'400':'200'}
    `;
  return (
    <Header>{children}</Header>
  )
}


